<template>
  <div>
    <CRUDCriteria :showReset='true' :showSearch='false' :showAdditionalActions='true'>
      <template v-slot:criteriaRows>
        <div class='mt-0 ml-6 mr-6 pa-0'>
          <v-row class='ma-n4'>
            <v-col cols="4" class="pt-0 pb-0">
            <v-text-field class="input-text-size" label="Wildcard Search - PID, TaxID, Name"
              v-model="criteriaState.wildCard"
              @input="searchByTimeOut" />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0">
                <v-select
                class="input-text-size"
                label="Resale Year"
                :items="saleYearItems"
                v-model="criteriaState.saleYear"
                item-text="name"
                item-value="value"
                @change="searchByCriteria" />
              </v-col>
              <v-col cols="2" class="pt-0 pb-0">
              <v-checkbox
                class="input-text-size tax-roll-criteria-unpaids-checkbox"
                @change="searchByCriteria"
                v-model="criteriaState.isItSold"
                label="Include Sold"
              />
            </v-col>
            <v-col cols="4" class="pt-0 pb-0 mt-3">
              <v-btn class="input-text-size" text
                color="blue darken-1" :loading="isPulling" :disabled="isPulling"
                @click="pullCountyOwnedRecords()">
                Pull County owned
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:additionalActions>
        <v-col cols='2' class='pt-2'>
        </v-col>
      </template>
    </CRUDCriteria>
  </div>
</template>
<script>
import {
  mapGetters, mapState,
} from 'vuex';
import CRUDCriteria from '../../../../common/base/crud-2.0/CRUDCriteria.vue';
import { SEARCH_DEBOUNCE_TIMER } from '../../../common-utils/constants';

export default {
  name: 'CommissionersPropertyCriteria',
  data() {
    return {
      dialogCrudKey: 'CommissionersProperty',
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'personalTaxWarrants',
    },
    isPulling: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CRUDCriteria,
  },
  computed: {
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      saleYearList: (state) => state.tax.juneResale.saleYearList,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    saleYearItems() {
      return [{ name: 'All Years', value: 0 }, ...(this.saleYearList || [])];
    },
  },

  methods: {
    searchByTimeOut() {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(() => {
        this.searchByCriteria();
      }, SEARCH_DEBOUNCE_TIMER);
    },
    searchByCriteria() {
      this.$emit('loadCRUDList');
    },
    pullCountyOwnedRecords() {
      this.$emit('pullCountyOwnedRecords');
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 0.85rem;
}
</style>
